module.exports = __webpack_public_path__ + "img/oculus_hifi_2.2906fb7b.png";